import { useQuery } from "@tanstack/react-query";

import { shouldRetryRequest } from "api/apiError";
import { fetchFleetHistory, fetchFleetOverview, fleetKeys } from "api/fleet";

const OVERVIEW_POLL_MS = 30 * 1000;
const HISTORY_POLL_MS = 5 * 60 * 1000;

/** Live fleet state (server, tenants, untracked apps); polls every 30 s. */
export const useFleetOverview = (enabled = true) =>
  useQuery({
    queryKey: fleetKeys.overview(),
    queryFn: fetchFleetOverview,
    retry: shouldRetryRequest,
    staleTime: OVERVIEW_POLL_MS / 2,
    refetchInterval: OVERVIEW_POLL_MS,
    enabled,
  });

/** Sampled history (host series, per-tenant uptime, incidents); polls every 5 min. */
export const useFleetHistory = (hours = 24, enabled = true) =>
  useQuery({
    queryKey: fleetKeys.history(hours),
    queryFn: () => fetchFleetHistory(hours),
    retry: shouldRetryRequest,
    staleTime: HISTORY_POLL_MS / 2,
    refetchInterval: HISTORY_POLL_MS,
    enabled,
  });
